import React, {useState} from 'react'
import {marked} from 'marked';
import { ChevronsDown } from 'lucide-react';
import Loading from '../../Loading';

const CompanyInformation = ({ title = '事業概要', description, marginTop = '' }) => {
    const [open, setOpen] = useState(false);
    const handleClick = () => {
        setOpen(!open);
    }

    if (description === null) {
        return <Loading />
    }

    return (
        <div className="dashboard-row" style={{
            paddingBottom: 5,
            ...(marginTop !== "" && { marginTop: marginTop }), 
        }} >
            <h3 className="dashboard">{title}</h3>
            {description ? 
                <div className={`company-info-container  description ${open ? "expanded text-gray-800" : "text-gray-500"}`} dangerouslySetInnerHTML={{ __html: marked(description) }}></div>
                    :
                    <div className={`company-info-container  description ${open ? "expanded text-gray-600" : "text-gray-500"}`} ></div>
            }
            <div className='flex justify-center items-center'>
                <ChevronsDown
                    className={`
                        ${open ? "rotate-180" : ""}
                        text-gray-500 hover:text-gray-600
                        hover:bg-gray-200
                        rounded-full
                        p-1 transition duration-200
                    `}
                    onClick={handleClick}
                    />
            </div>
        </div>
    ) 
}

export default CompanyInformation